<template>
    <div id="services" class="services">

        <div class="container">
            <p class="title"><b>Virtual</b> design, <b>Real</b> solutions</p>
            <p>MC2 COMUNICAZIONE è uno studio specializzato nella creazione di
                contenuti visivi realizzati con tecniche di computer grafica 3D.
                Affianchiamo i nostri clienti del settore dell&#39;architettura, dell&#39;industria e del
                design d&#39;arredo, con l&#39;obiettivo di dar forma e valore ad ogni loro progetto
                e prodotto.<br>
                Da 20 anni il nostro team di professionisti lavora ogni giorno con passione
                e creatività alla costante ricerca delle migliori tecniche di virtualizzazione,
                qualità che ci rendono partner affidabile al servizio di chi progetta.</p>
            <div class="row">
                <div class="col-lg-3 col-md-12">
                    <InfoList
                            icon="Immagini_3D_Icon.png"
                            title="Immagini 3D"
                            :items="['Rendering esterni','Rendering interni','Still Life','Immagini tecniche',
                            'Rendering 360','Planimetrie']"
                    />
                </div>
                <div class="col-lg-3 col-md-12">
                    <InfoList
                            icon="Video_3D_Icon.png"
                            title="Video 3D"
                            :items="['Video tour', 'Video lifestyle', 'Video tecnici']"
                    />
                </div>
                <div class="col-lg-3 col-md-12">
                    <InfoList
                            icon="Nuove_Tecnologie_Icon.png"
                            title="Nuove tecnologie"
                            :items="['Realtà virtuale', 'Realtà aumentata', 'Ologrammi']"
                    />
                </div>
                <div class="col-lg-3 col-md-12">
                    <InfoList
                            icon="Comunicazioni_Icon.png"
                            title="Comunicazione"
                            :items="['Brand identity', 'Immagine coordinata', 'Web', 'Social']"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="pt-5 contacts">CONTATTACI PER AVERE MAGGIORI DETTAGLI SU TUTTI I SERVIZI MC2</p>
                </div>
            </div>
            <div class="row py-3">
                <div class="col">
                    <a href="#contatti" type="button" class="btn button-gray px-4 py-3">contattaci</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import InfoList from "./InfoList";

    export default {
        name: "InfoSection",
        components: {InfoList},
    }
</script>

<style scoped>

</style>